module.exports = __webpack_public_path__ + "static/media/hashtag-nft-20.e5198f66.jpg";